import React, {Component} from 'react';
import axios from 'axios';
import {toast} from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import "./../css/App.css";

toast.configure()

const formValid = ({ formErrors, ...rest }) => {
    let valid = true;

    // validate form errors being empty
    Object.values(formErrors).forEach(val => {
        val.length > 0 && (valid = false);
    });

    // validate the form was filled out
    Object.values(rest).forEach(val => {
        val === null && (valid = false);
        formErrors.formFieldsEmpty = "Please provide Valid Values !!";
    });

    console.log("is Form Valid ", valid);
    return valid;
};

export default class AddUser extends Component {


    constructor(props){
        super(props);
        this.state = {
            isSubmit: false,
            paramUserID: null,
            paramFirstName: null,
            paramAddress: null,
            paramCity: null,
            paramLastName: null,
            paramRegion: null,
            paramTitle: null,
            paramCountry: null,
            paramUserCompanyName: null,
            paramPostalCode: null,
            paramPhone: null,
            paramStatus: null,
            paramFax: null,
            paramUserType: null,
            paramEMail: null,
            paramIsTerminalPrefix: null,
            paramIsAccountManager: null,
            paramIsNewTerminalID: null,
            paramIsCustomTerminalID: null,
            paramSQLPassword: null,
            paramTablePassword: null,
            paramParentUserID: null,
            paramCurrentUserID:null,
            formFieldsEmpty: null,
            errors:{},
            formErrors: {
                paramUserID: "",
                paramFirstName: "",
                paramCity: "",
                paramLastName: "",
                paramAddress: "",
                paramRegion: "",
                paramPhone: "",
                paramTitle: "",
                paramCountry: "",
                paramUserCompanyName: "",
                paramPostalCode: "",
                paramStatus: "",
                paramFax: "",
                paramUserType: "",
                paramEMail: "",
                paramIsTerminalPrefix: "",
                paramIsAccountManager: "",
                paramIsNewTerminalID: "",
                paramIsCustomTerminalID: "",
                paramSQLPassword: "",
                paramTablePassword: "",
                formFieldsEmpty: "",

            }
        };
    }

    componentDidMount() {

        axios.get(`getLoggedUserName?JSESSIONID=${sessionStorage.getItem('COOKIE')}`)
            .then(response => {

                this.setState({ loggedInUser: response.data })
                console.log("=== LOG_1 === Inside componentDidMount %s with data ","Add User",this.state.loggedInUser);
            }).finally(()=> {
            // this.hideLoader();
        })
            .catch(error => {
                console.log("GOT ERROR HERE for Get LoggedIn User",error);
            });
    }
    handleChange = event => {
        let formErrors = { ...this.state.formErrors };
        const { name, value } = event.target;

        switch (name) {
            case "paramUserID":
                formErrors.paramUserID =
                    (value.length < 3) ? "Minimum 3 characters required" : "";
                break;
            case "paramUserID":
                formErrors.paramUserID =
                    (!value) ? "Please Provide a Valid Input" : "";
                break;
            case "paramFirstName":
                formErrors.paramFirstName =
                    value.length < 3 ? "Minimum 3 characters required" : "";
                break;
            default:
                break;
        }

        // this.setState({ formErrors, [name]: value }, () => console.log(this.state));
        this.setState({formErrors, [event.target.name]: event.target.value });

    }


    //Validation for All empty Fields
    formValidation = () =>{
        const {paramUserID,paramFirstName} = this.state;
        let isValid = false;
        let errors = {};
        if (!paramUserID) {
            errors.paramUserID = 'Please enter valid Username';
        }if (!paramFirstName) {
            errors.paramFirstName = 'Please enter valid first Name';
        }else{
            isValid = true;
        }
        this.setState({errors});

        return isValid;
    }

    handleSubmit = event => {
        event.preventDefault();
        const user ={
            paramUserID: this.state.paramUserID,
            paramAddress: this.state.paramAddress,
            paramFirstName: this.state.paramFirstName,
            paramCity: this.state.paramCity,
            paramLastName: this.state.paramLastName,
            paramRegion: this.state.paramRegion,
            paramTitle: this.state.paramTitle,
            paramCountry: this.state.paramCountry,
            paramUserCompanyName: this.state.paramUserCompanyName,
            paramPostalCode: this.state.paramPostalCode,
            paramPhone: this.state.paramPhone,
            paramStatus: this.state.paramStatus,
            paramFax: this.state.paramFax,
            paramUserType: this.state.paramUserType,
            paramEMail: this.state.paramEMail,
            paramIsTerminalPrefix: this.state.paramIsTerminalPrefix,
            paramIsAccountManager: this.state.paramIsAccountManager,
            paramIsNewTerminalID: this.state.paramIsNewTerminalID,
            paramIsCustomTerminalID: this.state.paramIsCustomTerminalID,
            paramSQLPassword: this.state.paramSQLPassword,
            paramTablePassword: this.state.paramTablePassword,
            paramParentUserID: this.state.loggedInUser,
            paramCurrentUserID: this.state.loggedInUser
        };
        const isValid = this.formValidation();

        if(isValid) {
            axios.post(`addUser`, user)
                .then(res => {
                    alert('Data saved Successfully !!')
                    toast.success('Data saved Successfully !!', {position: toast.POSITION.TOP_CENTER,autoClose:1000})
                    console.log(res.paramStatus);
                }).catch(error => {
                    alert("Unable to add user !!")
                toast.error("Unable to add user !!", {position: toast.POSITION.TOP_CENTER,autoClose:1000})
                console.log(error);
            });
        }else{
            console.log(this.state);
            toast.error('Validation Failed!!', {position: toast.POSITION.TOP_CENTER,autoClose:1000})
        }

    }



    render() {
        const { formErrors } = this.state;
        const {paramUserID,paramFirstName,errors} = this.state;
        return <div className="tab-pane" id="tb_adduser" role="tabpanel">
            {Object.keys(errors).length>0 && (<span className="errorMessage">Please Input Required values !!</span>)}
            <form onSubmit={this.handleSubmit}>
                <div className="row">
                    <div className="col-md-6">
                        <h5 className="tbsub-paramTitle mt-3 mb-3">User Information</h5>
                        <div className="form-group">
                            <label className="control-label"><span style={{color: "red" }}>*</span>User Id </label>
                            <input type="text" name="paramUserID" className={formErrors.paramUserID.length > 0 ? "form-control error" : "form-control"}
                                   autoComplete="off" onChange={this.handleChange}
                                   placeholder="UserName"/>
                            {formErrors.paramUserID.length > 0 && (
                                <span className="errorMessage">{formErrors.paramUserID}</span>
                            )}
                        </div>
                        <div className="form-group">
                            <label className="control-label"><span style={{color: "red" }}>*</span>First Name</label>
                            <input type="text" name="paramFirstName" onChange={this.handleChange} className={formErrors.paramFirstName.length > 0 ? "form-control error" : "form-control"}
                                   placeholder="First Name"/>
                        </div>
                        {formErrors.paramFirstName.length > 0 && (
                            <span className="errorMessage">{formErrors.paramFirstName}</span>
                        )}
                        <div className="form-group">
                            <label className="control-label"><span style={{color: "red" }}>*</span>Last Name</label>
                            <input type="text" name="paramLastName" onChange={this.handleChange}
                                   className={formErrors.paramLastName.length > 0 ? "form-control error" : "form-control"}
                                   placeholder="Last Name"/>
                        </div>
                        {formErrors.paramLastName.length > 0 && (
                            <span className="errorMessage">{formErrors.paramLastName}</span>
                        )}
                        <div className="form-group">
                            <label className="control-label"><span style={{color: "red" }}>*</span>Title</label>
                            <input type="text" name="paramTitle" onChange={this.handleChange}
                                   className={formErrors.paramTitle.length > 0 ? "form-control error" : "form-control"}
                                   placeholder="Title"/>
                        </div>
                        <div className="form-group">
                            <label className="control-label"><span style={{color: "red" }}>*</span>Company</label>
                            <input type="text" name="paramUserCompanyName" onChange={this.handleChange}
                                   className={formErrors.paramUserCompanyName.length > 0 ? "form-control error" : "form-control"}
                                   placeholder="Company"/>
                        </div>
                    </div>
                    <div className="col-md-6">
                        <h5 className="tbsub-paramTitle mt-3 mb-3">User Location</h5>
                        <div className="form-group">
                            <label className="control-label"><span style={{color: "red" }}>*</span>Address</label>
                            <input type="text" name="paramAddress" onChange={this.handleChange}
                                   className={formErrors.paramAddress.length > 0 ? "form-control error" : "form-control"}
                                   placeholder="Address"/>
                        </div>
                        <div className="form-group">
                            <label className="control-label"><span style={{color: "red" }}>*</span>City</label>
                            <input type="text" name="paramCity" onChange={this.handleChange}
                                   className={formErrors.paramCity.length > 0 ? "form-control error" : "form-control"}
                                   placeholder="City"/>
                        </div>
                        <div className="form-group">
                            <label className="control-label"><span style={{color: "red" }}>*</span>Region</label>
                            <input type="text" name="paramRegion" onChange={this.handleChange}
                                   className={formErrors.paramRegion.length > 0 ? "form-control error" : "form-control"}
                                   placeholder="Region"/>
                        </div>
                        <div className="form-group">
                            <label className="control-label">Country</label>
                            <select name="paramCountry" onChange={this.handleChange}
                                    className={formErrors.paramCountry.length > 0 ? "form-control error" : "form-control select2"}>
                                <option value="NA">Select Country</option>
                                <option value="USA">United States</option>
                                <option value="MEX">Mexico</option>
                                <option value="EUR">Europe</option>
                                <option value="CAN">Canada</option>
                                <option value="IND">India</option>
                                <option value="UK">United Kingdom</option>
                            </select>
                        </div>
                        <div className="form-group">
                            <label className="control-label"><span style={{color: "red" }}>*</span>Zip Code</label>
                            <input type="text" name="paramPostalCode" onChange={this.handleChange}
                                   className={formErrors.paramPostalCode.length > 0 ? "form-control error" : "form-control"}
                                   placeholder="Postal Code"/>
                        </div>
                    </div>
                </div>
                <div className="row">
                    <div className="col-md-6">
                        <h5 className="tbsub-paramTitle mt-3 mb-3"><span style={{color: "red" }}>*</span>Contact</h5>
                        <div className="form-group">
                            <label className="control-label">Phone</label>
                            <input type="text" name="paramPhone" onChange={this.handleChange}
                                   className={formErrors.paramPhone.length > 0 ? "form-control error" : "form-control"}
                                   placeholder="Phone"/>
                        </div>
                        <div className="form-group">
                            <label className="control-label">Fax</label>
                            <input type="text" name="paramFax" onChange={this.handleChange}
                                   className={formErrors.paramFax.length > 0 ? "form-control error" : "form-control"}
                                   placeholder="Fax"/>
                        </div>
                        <div className="form-group">
                            <label className="control-label">Email</label>
                            <input type="text" name="paramEMail" onChange={this.handleChange}
                                   className={formErrors.paramEMail.length > 0 ? "form-control error" : "form-control"}
                                   placeholder="johndoe@example.com"/>
                        </div>
                    </div>
                    <div className="col-md-6">
                        <h5 className="tbsub-paramTitle mt-3 mb-3">Other</h5>
                        <div className="form-group">
                            <label className="control-label">Status</label>
                            <select name="paramStatus" onChange={this.handleChange}
                                    className={formErrors.paramStatus.length > 0 ? "form-control error" : "form-control select2"}>
                                <option value="-1">Select Status</option>
                                <option value="AC">Active</option>
                                <option value="IA">InActive</option>
                            </select>
                        </div>
                        <div className="form-group">
                            <label className="control-label">Type</label>
                            <select name="paramUserType" onChange={this.handleChange}
                                    className={formErrors.paramUserType.length > 0 ? "form-control error" : "form-control select2"}>
                                <option value="-1">Select Type</option>
                                <option value="0">Private</option>
                                <option value="1">Public</option>
                            </select>
                        </div>
                    </div>
                </div>
                <div className="row mt-4 align-items-end">
                    <div className="col-md-6">
                        <div className="us_checkouter">
                            <div className="form-check mb-2">
                                <input type="checkbox" name="paramIsAccountManager" className="form-check-input"
                                       onChange={this.handleChange}
                                       id="paramIsAccountManager"/>
                                <label className="form-check-label" htmlFor="chkbox1">Can
                                    this user access Account Manager?</label>
                            </div>
                            <div className="form-check mb-2">
                                <input type="checkbox" name="paramIsNewTerminalID" className="form-check-input"
                                       onChange={this.handleChange}
                                       id="paramIsNewTerminalID"/>
                                <label className="form-check-label" htmlFor="chkbox2">Can
                                    this user Create a New Terminal?</label>
                            </div>
                            <div className="form-check mb-2">
                                <input type="checkbox" name="paramIsCustomTerminalID" className="form-check-input"
                                       onChange={this.handleChange}
                                       id="paramIsCustomTerminalID"/>
                                <label className="form-check-label" htmlFor="chkbox3">Can
                                    this user Custom a Terminal ID?</label>
                            </div>
                        </div>
                    </div>
                    <div className="col-md-6">
                        <div className="form-group mt-3 mb-2">
                            <label className="control-label">Prefix Terminal ID</label>
                            <input type="text" name="paramIsTerminalPrefix" onChange={this.handleChange}
                                   className={formErrors.paramIsTerminalPrefix.length > 0 ? "form-control error" : "form-control"}
                                   placeholder="Prefix Terminal ID"/>
                        </div>
                    </div>
                </div>
                <div className="mt-4 sect_umupload">
                    <div className="row">
                        <div className="col-sm-8">
                            <div className="form-group">
                                <label className="control-label">Upload Logo</label>
                                <div className="input-group mb-3">
                                    <div className="custom-file mb-3">
                                        <input type="file" className="custom-file-input"
                                               id="File1" name="filename"/>
                                        <label className="custom-file-label"
                                               htmlFor="customFile">Choose file</label>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="col-sm-4 mt-4">
                            <div className="form-group">
                                <button type="button"
                                        className="btn btn-secondary btn-outline-dark">Choose
                                    Default
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
                <div className="row">
                    <div className="col-md-6">
                        <h5 className="tbsub-paramTitle mt-3 mb-3">Change Password</h5>
                        <div className="form-group">
                            <input type="password" name="paramSQLPassword" onChange={this.handleChange}
                                   className={formErrors.paramSQLPassword.length > 0 ? "form-control error" : "form-control"}
                                   placeholder="Password"/>
                        </div>
                    </div>
                    <div className="col-md-6">
                        <div className="form-group">
                            <h5 className="tbsub-paramTitle mt-3 mb-3">&nbsp;</h5>
                            <input type="password" name="paramTablePassword" onChange={this.handleChange}
                                   className={formErrors.paramTablePassword.length > 0 ? "form-control error" : "form-control"}
                                   placeholder="Confirm Password"/>
                        </div>
                    </div>
                </div>
                <div className="row mt-5 justify-content-md-center">
                    <div className="col-md-4">
                        <button type="submit" className="btn btn-block btn-primary w-md">Save
                        </button>
                    </div>
                </div>
            </form>
        </div>
    }
}

